import { Avatar, Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { LoggedUser } from "../../atoms/userLogged";
import ProfileDrawer from "./components/profileDrawer";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../atoms/customColors";
import ModalChangePassword from "./components/modalChangePassword";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../routes/privateRoute";
import moment from "moment";
import Login from "../../services/loginApi";
import { useCookies } from "react-cookie";
import { isAuthenticated } from "../../atoms/isAuthenticated";
import { useRecoilValue } from "recoil";
import { apiResponseState } from "./../../atoms/loginState";
import axios from "axios";

function Header({ setOpen, open }: any) {
  const apiResponse: any = useRecoilValue(apiResponseState);
  const user = useRecoilState(LoggedUser)[0];
  const [isOpen, setIsOpen] = useState(false);
  const colors = useRecoilState(customColors)[0];

  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();

  const refreshToken = cookies.refreshToken
    ? cookies.refreshToken
    : localStorage.getItem("refreshToken");
  const token = cookies.token ? cookies.token : localStorage.getItem("token");

  let jwtToken: JWTToken = {
    email: "",
    exp: 0,
    iat: 0,
    idCliente: "",
    idEmpresa: "",
    name: "",
    nbf: 0,
    primarysid: "",
    role: "",
  };
  let jwtRefreshToken: JWTToken = {
    email: "",
    exp: 0,
    iat: 0,
    idCliente: "",
    idEmpresa: "",
    name: "",
    nbf: 0,
    primarysid: "",
    role: "",
  };

  if (token && typeof token === "string" && token.includes(".")) {
    try {
      jwtToken = jwt_decode(token);
    } catch (error) {
      console.error("Failed to decode token:", error);
    }
  }

  if (
    refreshToken &&
    typeof refreshToken === "string" &&
    refreshToken.includes(".")
  ) {
    try {
      jwtRefreshToken = jwt_decode(refreshToken);
    } catch (error) {
      console.error("Failed to decode refreshToken:", error);
    }
  }

  function formatRemainingTime(expirationTime: number): string {
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const remainingTimeInSeconds = expirationTime - currentTimeInSeconds;

    const hours = Math.floor(remainingTimeInSeconds / 3600);
    const minutes = Math.floor((remainingTimeInSeconds % 3600) / 60);

    if (hours > 0) {
      return `${hours} horas`;
    } else {
      return `${minutes} minutos`;
    }
  }
  let remainingTime = formatRemainingTime(jwtRefreshToken.exp);

  const primeiroAcesso = apiResponse?.user?.primeiroAcesso;
  useEffect(() => {
    if (primeiroAcesso) {
      setOpenChangePassword(true);
    } else {
      setOpenChangePassword(false);
    }
  }, []);

  // Evita derrubar a sessão ao dar F5 / em falhas transitórias do refresh:
  // só desloga se o access token atual já estiver expirado.
  function isAccessTokenValid(): boolean {
    if (!token || typeof token !== "string" || !token.includes(".")) {
      return false;
    }
    try {
      const decoded: JWTToken = jwt_decode(token);
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  }

  function forceLogout() {
    removeCookie("auth", { path: "/" });
    removeCookie("token", { path: "/" });
    removeCookie("refreshToken", { path: "/" });
    window.localStorage.clear();
    window.location.href = "/login";
  }

  async function GetNewToken() {
    const obj = {
      refreshToken: refreshToken,
    };
    try {
      const response = await Login.refreshToken(obj);
      if (response.status >= 200 && response.status < 300) {
        setCookie("auth", response.data.token, { path: "/" });
        setCookie("token", response.data.token, { path: "/" });
        window.localStorage.setItem("token", response.data.token);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.token}`;
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      // Mantém a sessão se o token ainda é válido (não desloga no F5 por falha do refresh)
      if (!isAccessTokenValid()) {
        forceLogout();
      }
    }
  }

  async function GetNewTokenAfterDesactivatedScreen() {
    const obj = {
      refreshToken: refreshToken,
    };
    try {
      const response = await Login.GetNewTokenAfterDesactivatedScreen(obj);
      setCookie("auth", response.token, { path: "/" });
      setCookie("token", response.token, { path: "/" });
      window.localStorage.setItem("token", response.token);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.token}`;
    } catch (error) {
      console.error("Token refresh after desactivated screen failed:", error);
      // Mantém a sessão se o token ainda é válido (não desloga no F5 por falha do refresh)
      if (!isAccessTokenValid()) {
        forceLogout();
      }
    }
  }

  useEffect(() => {
    let interval: NodeJS.Timeout;

    const handleVisibilityChange = () => {
      const isVisible = !document.hidden;
      if (isVisible) {
        console.log("Page visible, refreshing token...");
        clearInterval(interval);
        GetNewTokenAfterDesactivatedScreen();
        interval = setInterval(() => {
          console.log("Running GetNewToken...");
          GetNewToken();
        }, 300000); // 5 minutes
      } else {
        console.log("Page hidden, stopping token refresh...");
        clearInterval(interval);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    handleVisibilityChange();

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(interval);
    };
  }, [refreshToken]);

  const version = "2026.07.15.1";

  return (
    <Flex
      justify={!open ? "space-between" : "space-between"}
      align="center"
      w={"100%"}
      h={"80%"}
      my={2}
    >
      {!open ? (
        <Button bg={"none"} onClick={() => setOpen(true)}>
          <FaBars size={"10px"} />
        </Button>
      ) : (
        <></>
      )}
      <Text fontSize={"15"} fontWeight={"medium"} ml={"3%"}>
        {`Vers. ${version} | Sua sessão termina em: ${remainingTime}`}
      </Text>
      <Flex
        justify="center"
        align="center"
        bgColor={colors.BLUEMONEDDBUTTONS}
        w={"16vw"}
        h={"100%"}
        borderLeftRadius={"30px"}
      >
        <Flex direction="column" align="flex-end" justifyContent={"center"}>
          <Text fontSize={"1.5vh"} fontWeight="medium" color={"white"}>
            {user.nome
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase())}
          </Text>
          <Text fontSize={"1.3vh"} color={"white"}>
            {(user.idLoginTipo === 1 && "Gestor") ||
              (user.idLoginTipo === 2 && "Filial") ||
              (user.idLoginTipo === 3 && "Supervisor") ||
              (user.idLoginTipo === 4 && "Cliente") ||
              (user.idLoginTipo === 5 && "Comissionado")}
          </Text>
        </Flex>
        <Box
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <Avatar
            name={user.nome}
            color={colors.BLUEMONEDDBUTTONS}
            ml="3"
            size="sm"
            bg={colors.WHITE}
          />
        </Box>
        <ProfileDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
        <ModalChangePassword
          isOpen={openChangePassword}
          setIsOpen={setOpenChangePassword}
          user={user}
        />
      </Flex>
    </Flex>
  );
}
export default Header;
